import React, { useState } from 'react';
import { SignUpModal } from '../../../components/shared/SignUpModal';
 

import { MilanCredit } from '../../../components/specials/home/MilanCredit';

export default function MilanCreditBuilder({ siteData }) {
    const [showSignUpModal, setShowSignUpModal] = useState(false);

    return (
        <div>
            {showSignUpModal && <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />}
            <MilanCredit setShowSignUpModal={setShowSignUpModal} globalData={siteData?.globalData} />
        </div>
    );
}
